import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=0b7aaed0&scoped=true"
import script from "./Clip.vue?vue&type=script&lang=ts"
export * from "./Clip.vue?vue&type=script&lang=ts"
import style0 from "./Clip.vue?vue&type=style&index=0&id=0b7aaed0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7aaed0",
  null
  
)

export default component.exports